<template>
    <div class="comment-box main-shadow">
        <div class="comment-box__title">
            Comments
        </div>
      
        <div class="comments" ref="comments">  
            <div class="comments__item" v-for="item in comments" :key="item.id">
                <div class="comments__head">
                    <span>{{item.user || 'Admin'}}</span>
                    <span>{{dateFormat(item.created_at)}}</span>
                </div>
                <div class="comments__body">
                    <div>
                        <p>{{item.comment}}</p>
                    </div>
                </div>
            </div>  
        </div>

        <div class="comments__leave">
            <el-input
                type="textarea"
                :rows="4"
                placeholder="Please input"
                v-model="comment"
            >
            </el-input>

            <button 
                class="main-btn main-btn_mt main-btn_ml--auto"
                :class="{
                    'main-btn_disabled': !isValid
                }"
                :disabled="!isValid"
                @click="createComment"
            >Create</button> 
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex';
import dateMixin from '@/mixins/dateMixin';

export default {
    name: 'main-comments',
    props: {
        comments: {
            required: true
        },
        id: {
            required: true
        },
        cb: {
            required: false
        }
    },
    mixins: [dateMixin],
    computed: {
        isValid() {
            if(this.comment == '') {
                return false;
            }

            return true; 
        }
    },
    data() {
        return {
            comment: ''
        }
    },
    methods: {
          ...mapActions({ 
            getCompare: 'comparing/get',
            getFavs: 'favorites/get',
            addComment: 'simulation/addComment'
        }),
        toTop() {
            this.$refs.comments.scrollTop = 0;
        },
        clearComments() {
            this.comment = '';
        },
        async createComment() {   
            await this.addComment({
                comment: this.comment,
                id: this.id
            });  
            
            this.clearComments();
            this.toTop();   
            
            if(this.$route.name == 'Favs') {
                await this.getFavs();
                return;
            }  
           
            await this.getCompare(); 
        }
    }
}
</script>
<style lang="scss" scoped>

.comment-box {
    max-width: 400px;
    width: 95%;
    margin-top: 10px;
    padding: 15px;

    &__title {
        font-size: 24px; 
    }
} 

.comments {
    overflow-y: auto;
    height: 80px;
    transition: all .3s ease-in;

    &__leave {
        margin-top: 24px;
    }

    &__head {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        font-size: 13px;
        color: #4a4c4e;
    }

    &__item {
        padding-bottom: 12px;
        padding-top: 24px;
        animation: fromOpacity .3s ease-in;
    }

    &__body {

        p {
            line-height: 130%;
            color: #383838;
        } 
    }
}

.comments__item:not(:last-child) {
    border-bottom: 1px solid rgba(178, 180, 183, 0.25);
} 
</style>